<template>
    <div class="col-sm-12">
            <div class="form-group row">
                <label class="col-sm-2 col-form-label required">Désignation</label>
                <div class="col-sm-8">
                    <input class="form-control form-control-sm" :id="'lotAutocomplete' + lot.uniq" type="text" :name="'lots[' + index + '][designation]'" v-model="lot.name" required> 
                </div>
                <!-- Lot en option : chiffré à part, hors du total de l'étude et du devis -->
                <div class="col-sm-2 d-flex align-items-center" v-if="optionsEnabled || lot.is_optional">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" :id="'lot_is_optional_' + lot.uniq" v-model="lot.is_optional">
                        <label class="custom-control-label ix-nowrap" :for="'lot_is_optional_' + lot.uniq">Lot en option</label>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-2 col-form-label">Description</label>
                <div class="col-sm-8">
                    <textarea class="form-control" :id="'lots[' + index + '][description]'" :name="'lots[' + index + '][description]'" v-model="lot.description"></textarea>
                </div> 
            </div>
            <input type="hidden" :value="lot.is_optional ? 1 : ''" :name="'lots[' + index + '][is_optional]'">
            <input type="hidden" class="form-control" :value="lot.id" :name="'lots[' + index + '][lot_id]'">
            <input type="hidden" class="form-control" :value="lot.name" :name="'lots[' + index + '][name]'">
            <input type="hidden" class="form-control" :value="lot.number" :name="'lots[' + index + '][number]'">
    </div>
</template>


<script>
export default {
    name: 'prediction-lot-form',
    props: ['lot', 'index', 'lotRoute', 'optionsEnabled'],
    data(){
        return {
            suggestionLots: []
        }
    },
    mounted(){
    },
   
}
</script>